var map = {
	"./flag-AR.png": "c90c",
	"./flag-AU.png": "dbeb",
	"./flag-BO.png": "f91f",
	"./flag-BR.png": "b25f",
	"./flag-CA.png": "22ec",
	"./flag-CL.png": "dc79",
	"./flag-CO.png": "45f2",
	"./flag-CR.png": "2e04",
	"./flag-DE.png": "b845",
	"./flag-DO.png": "7a3f",
	"./flag-EC.png": "0203",
	"./flag-ES.png": "8394",
	"./flag-FR.png": "493e",
	"./flag-GT.png": "205a",
	"./flag-HN.png": "4b24",
	"./flag-IL.png": "e0fd",
	"./flag-IR.png": "2ecb",
	"./flag-IT.png": "2fd5",
	"./flag-JP.png": "e77f",
	"./flag-MX.png": "a3c3",
	"./flag-MY.png": "00b8",
	"./flag-OUTROS.png": "e93e",
	"./flag-PA.png": "3ea1",
	"./flag-PE.png": "0472",
	"./flag-PR.png": "45b9",
	"./flag-PT.png": "301f",
	"./flag-PY.png": "2dfa",
	"./flag-UK.png": "2d90",
	"./flag-US.png": "7d12",
	"./flag-UY.png": "6c65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b913";